import { defineComponent as _defineComponent } from 'vue';
import PaginationControls from "@/components/ui/pagination/PaginationControls.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginatorControls',
    props: {
        dataset: { type: null, required: true },
        maxVisiblePages: { type: Number, required: false, default: 5 }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, PaginationControls };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
